import React, { useState } from 'react';
import { ArrowLeft } from 'lucide-react';

const APPS = [
    { id: 'supermath', label: 'SuperMath' },
    { id: 'leonora', label: "Leonora's Colors" },
];

const TermsOfUse = ({ onBack }) => {
    const [activeApp, setActiveApp] = useState('supermath');

    return (
        <div className="legal-page">
            <div className="legal-container">
                <button className="legal-back" onClick={onBack}>
                    <ArrowLeft size={20} />
                    Back to Home
                </button>

                <h1>Terms of Use</h1>

                <div className="legal-tabs">
                    {APPS.map((app) => (
                        <button
                            key={app.id}
                            className={`legal-tab ${activeApp === app.id ? 'active' : ''}`}
                            onClick={() => setActiveApp(app.id)}
                        >
                            {app.label}
                        </button>
                    ))}
                </div>

                {activeApp === 'supermath' && (
                    <div className="legal-iframe-wrapper">
                        <iframe
                            src="https://www.mathematicalrun.com/#/terms"
                            title="SuperMath Terms of Use"
                            className="legal-iframe"
                        />
                    </div>
                )}

                {activeApp === 'leonora' && (
                    <>
                        <p className="legal-updated">Last Updated: February 5, 2026</p>

                        <p>
                            Welcome to <strong>Leonora's Colors</strong>. Use of this application is governed by the
                            following terms. By downloading or using the app, you agree to these conditions.
                        </p>

                        <h2>1. Acceptance and Minors</h2>
                        <p>
                            Leonora's Colors is an educational app designed for preschool-age children. If the user is
                            a minor, acceptance of these Terms must be performed by a parent or legal guardian. Use of the
                            app implies that a parent has authorized the minor to use it.
                        </p>

                        <h2>2. Service Usage</h2>
                        <p>
                            The application is provided for personal, non-commercial use. The app works fully offline
                            and does not require an internet connection.
                        </p>

                        <h2>3. Intellectual Property</h2>
                        <p>
                            All content (graphics, logos, code, sounds, animations) is the exclusive property of
                            EagleTap SRL. Copying, decompiling, or distributing parts of the app is prohibited.
                        </p>

                        <h2>4. Limitation of Liability</h2>
                        <p>
                            The software is provided "As-Is". EagleTap SRL does not guarantee that the app will be
                            error-free or always accessible.
                        </p>
                        <p>
                            EagleTap SRL is not liable for any loss of game progress due to app uninstallation or
                            device changes.
                        </p>

                        <h2>5. Governing Law</h2>
                        <p>
                            These terms are governed by Italian law. For any dispute regarding consumers, the competent
                            court is that of the user's place of residence.
                        </p>

                        <h2>6. Contacts</h2>
                        <p>
                            For technical support or reports: <strong>support@eagletap.com</strong>
                        </p>
                    </>
                )}
            </div>
        </div>
    );
};

export default TermsOfUse;
